module.exports = __webpack_public_path__ + "static/pichance-d565a0278bd44f716a0d74582aeb9456.png";